// extracted by mini-css-extract-plugin
export default {"mobileHeaderRoot":"mobileHeader_mobileHeaderRoot__YC943","backButton":"mobileHeader_backButton__gAABC"};